import { forwardRef } from 'react';

export const UiTextarea = forwardRef(function UiTextarea(
  {
    label,
    error,
    className = '',
    style,
    textareaClassName = '',
    rows = 4,
    ...textareaProps
  },
  ref,
) {
  return (
    <label className={`ui-field ${className}`.trim()} style={style}>
      {label ? <span className="ui-field__label">{label}</span> : null}
      <textarea
        {...textareaProps}
        ref={ref}
        rows={rows}
        className={`ui-control ui-control--textarea ${textareaClassName}`.trim()}
      />
      {error ? <span className="form-error">{error}</span> : null}
    </label>
  );
});
